<template>
	<action-card
		v-if="subscriptionRequests.length"
		:title="$t('subscriptions.heading')"
		icon="repeat"
		:count="subscriptionRequests.length"
		@open="$router.push('/invoices?v=subscriptions')"
	>
		<button
			v-for="request in visibleRequests"
			:key="request.id"
			type="button"
			class="portal-action-row"
			@click="openRequest(request)"
		>
			<span class="action-row-copy">
				<template v-for="(product, index) in request.productSelections">
					<strong :key="`name-${index}`">{{ product.quantity }} × {{ product.subscriptionProduct.name }}</strong>
					<small :key="`price-${index}`">
						{{
							$formatters.dollars(
								product.subscriptionProduct.prices[0].unitAmount / 100,
								true,
								true,
								product.subscriptionProduct.prices[0].currency
							)
						}}
					</small>
				</template>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';

	export default {
		name: 'SubscriptionRequests',

		props: ['subscriptionRequests'],

		components: { ActionCard },

		methods: {
			openRequest(request) {
				window.location.href = request.checkoutUrl;
			},
		},

		computed: {
			visibleRequests() {
				return this.subscriptionRequests.slice(0, 5);
			},
		},
	};
</script>
